import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators'; // Ensure this is imported

// class IdleTimer {
//     constructor({ timeout, onTimeout,refreshtoken }) {
//       this.timeout = timeout;
//       this.onTimeout = onTimeout;
//       this.refreshtoken = refreshtoken;
//       this.eventHandler = this.updateExpiredTime.bind(this);
//      // this.tracker();
//      // this.startInterval();
//     }
  
//     startInterval() {
//       this.updateExpiredTime();
//       this.interval = setInterval(() => {
//         const expiredTime = parseInt(sessionStorage.getItem("_expiredTime"), 10);
//       //  if (!(window.location.href.includes('myProfile') || window.location.href.includes('myDashboard')|| window.location.href.includes('myAccess'))) {
//           if(expiredTime < Date.now()){
//             if (this.onTimeout) {
//               this.onTimeout();
//               this.cleanUp();
//             }
//           }
//        // }
//         //We can Put here condition to refresh The Token
//         var refrTime = parseInt(sessionStorage.getItem("refreshTokenTime"), 10); 
//         if(refrTime < Date.now()){
//           if (this.refreshtoken) {
//             this.refreshtoken();
//           }
//         }
//       }, 10000);
//     }
  
//     updateExpiredTime() {
//       if (this.timeoutTracker) {
//         clearTimeout(this.timeoutTracker);
//       }
  
//       this.timeoutTracker = setTimeout(() => {
//         sessionStorage.setItem("_expiredTime", Date.now() + this.timeout * 1000);
//       }, 300);
//     }
  
//     tracker() {
//       window.addEventListener("mousemove", this.eventHandler);
//       window.addEventListener("scroll", this.eventHandler);
//       window.addEventListener("keydown", this.eventHandler);
//     }
  
//     cleanUp() {
//       clearInterval(this.interval);
//       window.removeEventListener("mousemove", this.eventHandler);
//       window.removeEventListener("scroll", this.eventHandler);
//       window.removeEventListener("keydown", this.eventHandler);
//     }
//   }
//   export default IdleTimer;
  

class IdleTimer {
  constructor({ timeout, onTimeout, refreshtoken, warningTime, router,modalService,toasterService,inactivetime  }) {
    this.timeout = timeout * 1000; // Convert timeout to milliseconds (30 minutes)
    //this.inactivityLimit = 8 * 60 * 1000; // 15 minutes in milliseconds
    this.inactivityLimit = 5 * 60 * 1000; // 15 minutes in milliseconds
    this.warningTime = warningTime * 1000; // Time before expiration to refresh token (e.g., 2 minutes before)
    this.onTimeout = onTimeout; // Logout function when session expires
    this.refreshtoken = refreshtoken; // Function to call refresh token API
    this.router = router; // Angular Router instance for tracking route changes
    this.eventHandler = this.resetTimers.bind(this);
    this.startTimers(); // Start monitoring activity and session
    this.startActivityTracking(); // Start tracking user activity
    this.isSessionTimedOut = false; // Flag to track if session has timed out
    this.modalService = modalService; // Store the injected modalService
    this.sessionWarningModal = null; // Store modal instance
    this.toasterService = toasterService; // Store the injected toasterService
    this.isWarningPopupShow = false;
    this.isLogoutPopupShow = false;
  }

  // Start the expiration, refresh, and inactivity timers
  startTimers() {
    //this.updateExpirationTime();
    this.updateInactivityTimer();
    this.inactivityLimit = parseInt(sessionStorage.getItem("inactivityLimit")) * 60 * 1000;
    this.interval = setInterval(() => {
      const expiredTime = parseInt(sessionStorage.getItem("_expiredTime"), 10);
      const refreshTokenTime = parseInt(sessionStorage.getItem("refreshTokenTime"), 10);
      //const newExpirationTime = Date.now() + this.timeout;
      //const refreshTime = expiredTime - this.warningTime;
      const refreshTime = refreshTokenTime - this.warningTime;
      const currentTime = Date.now();
      //console.log("startTimers expiredTime",Date(expiredTime.toString()));
      //console.log("startTimers refreshTime",new  Date(refreshTime.toString()));
      //console.log("startTimers currentTime",new  Date(currentTime.toString()));
      // console.log("startTimers currentTime",currentTime);
      // console.log("startTimers refreshTime",refreshTime);
      // console.log("startTimers expiredTime",expiredTime);
      const inactiveMinutes = this.getInactiveTimeInMinutes();
      //console.log("Inactive time in minutes:", inactiveMinutes);
      // Check if it's time to refresh the token (2 minutes before expiration)
      //if (currentTime >= refreshTime && currentTime < expiredTime) {
      //if (currentTime >= refreshTime && !this.isWarningPopupShow) {
      if (currentTime > expiredTime && inactiveMinutes < parseInt(sessionStorage.getItem("inactivityLimit")) && !this.isWarningPopupShow) {
        // alert("refresh");
        // this.refreshtoken?.(); // Call the refresh token function
        // this.updateExpirationTime(); // Update expiration time after token is refreshed
        //this.showSessionWarningPopup();
        this.refreshtoken(); // Call the refresh token API
        //this.updateExpirationTime(); // Reset expiration time
      }else if (currentTime >= refreshTokenTime && !this.isLogoutPopupShow) {
        this.showSessionOutPopup();
      }
      // if ((Date.now() - this.lastActivityTime > this.inactivityLimit) && !this.isWarningPopupShow) {
      //   // this.onTimeout?.(); // Trigger logout and redirect to home
      //   // this.cleanUp(); // Clean up event listeners and timers
      //   this.showSessionWarningPopup();
      // }

      // Check if the session has expired
      // if (currentTime >= expiredTime && !this.isSessionTimedOut) {
      //   alert("expire token");
      //   this.isSessionTimedOut = true; // Mark the session as timed out
      //   this.onTimeout?.(); // Trigger logout if session has expired
      //   this.cleanUp(); // Clean up event listeners and intervals
      // }
    }, 5000); // Run every 10 seconds to check expiration and refresh
  }

  // Reset the inactivity timer on user activity
  resetTimers() {
    clearTimeout(this.inactivityTimer); // Reset inactivity timer

    // If the user has been inactive for more than 15 minutes
    if ((Date.now() - this.lastActivityTime > this.inactivityLimit) && !this.isWarningPopupShow) {
      // this.onTimeout?.(); // Trigger logout and redirect to home
      // this.cleanUp(); // Clean up event listeners and timers
      //this.showSessionWarningPopup();
    } else {
      // User is still active, reset the activity time
      this.lastActivityTime = Date.now();
      this.updateInactivityTimer(); // Reset the inactivity timer
    }
  }

  // Update the expiration time (e.g., 30 minutes from now)
  updateExpirationTime() {
    //debugger;
    const expirationTime = Date.now() + this.timeout; // Set expiration time
    sessionStorage.setItem("_expiredTime", expirationTime.toString()); // Store expiration in localStorage
    const refreshTokenTime = Date.now() + (this.timeout * 2);
    sessionStorage.setItem("refreshTokenTime", refreshTokenTime.toString());
    this.updateInactivityTimer();
  }

  // Start the inactivity timer (logout if no activity for 15 minutes)
  updateInactivityTimer() {
    this.lastActivityTime = Date.now(); // Store the last activity time
   // console.log("updateInactivityTimer lastActivityTime",this.lastActivityTime)
    this.inactivityTimer = setTimeout(() => {
      // this.cleanUp(); // Clean up event listeners and timers
      // this.onTimeout?.(); // Trigger logout if user has been inactive for 15 minutes
      this.isWarningPopupShow=true;
      
      //Temprary commit
      //this.showSessionWarningPopup();
    }, this.inactivityLimit); // Set timeout for 15 minutes of inactivity
  }

  // Start tracking user activity (mouse, scroll, keydown)
  // startActivityTracking() {
  //   //["mousemove", "scroll", "keydown", "click"].forEach(event => {
  //     ["click", "popstate"].forEach(event => {
  //       window.addEventListener(event, this.eventHandler.bind(this));
  //     });

  //   // // Track route changes using Angular Router
  //   // this.router.events
  //   //   .pipe(filter(event => event instanceof NavigationEnd))
  //   //   .subscribe(() => {
  //   //     this.eventHandler(); // Call the event handler on route change
  //   //   });

  //   this.eventHandler = (e) => {
  //     if (e.type === "click") {
  //       const target = e.target; // No type assertion needed in JavaScript
  //       if (target.tagName.toLowerCase() === "button" || target.getAttribute("role") === "button") {
  //         this.resetTimers(); // Reset timers on button click
  //       }
  //     } else if (e.type === "popstate") {
  //       this.resetTimers(); // Handle route changes
  //     }
  //   };
  // }

  startActivityTracking() {
    // Define eventHandler first
    this.eventHandler = (e) => {
      if (e.type === "click") {
        //const target = e.target; // No type assertion needed in JavaScript
        //if (target.tagName.toLowerCase() === "button" || target.getAttribute("role") === "button") {
          this.resetTimers(); // Reset timers on button click
        //}
      }
      //else if (e.type === "popstate") {
      //  this.resetTimers(); // Handle route changes
      //}
      else if (["keydown", "keyup","mousemove", "scroll"].includes(e.type)) {
        this.resetTimers();// Handle other activity types
      }
    };

    //Now add event listeners after defining eventHandler
    ["click", "popstate",'mousemove', 'keydown', 'keyup', 'scroll'].forEach(event => {
      window.addEventListener(event, this.eventHandler.bind(this));
    });

    // Track route changes using Angular Router
    this.routerSubscription = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.resetTimers();
      });
  }

  // Clean up intervals and event listeners
  cleanUp() {
    clearInterval(this.interval); // Stop the session interval
    clearTimeout(this.inactivityTimer); // Clear the inactivity timer
    ["mousemove", "scroll", "keydown", 'keyup', 'scroll',"click", "popstate"].forEach(event => {
      window.removeEventListener(event, this.eventHandler); // Remove event listeners
    });
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
    sessionStorage.removeItem("refreshTokenTime");
    sessionStorage.removeItem("_expiredTime");
    //this.toasterService.show("Your session has expired, Please Login again", { class: 'warning', title: '' });
    //sessionStorage.removeItem("userData");
    this.isWarningPopupShow=false;
    this.isLogoutPopupShow=false;
  }

  // showSessionWarningPopup() {
  //   // // Assuming you have a modal service that opens modals
  //   // this.modalService.open({
  //   //   title: 'Session Expiration',
  //   //   message: 'Your session will expire in a few minutes. Do you want to continue?',
  //   //   confirmText: 'Yes',
  //   //   cancelText: 'No'
  //   // }).then(result => {
  //   //   if (result === 'yes') {
  //   //     this.refreshtoken(); // Call the refresh token API
  //   //     this.updateExpirationTime(); // Reset expiration time
  //   //     this.isPopupShown = false; // Reset popup flag
  //   //   } else {
  //   //     this.handleSessionTimeout(); // Handle session timeout
  //   //   }
  //   // }).catch(() => {
  //   //   // If the user closes the modal without action
  //   //   this.handleSessionTimeout();
  //   // });

  //   if (this.confirmDialog) {
  //     this.confirmDialog.title = 'Confirmation Message';
  //     this.confirmDialog.message = `Are you sure you wish to clear the entered details?\nThis action cannot be undone.`;
  //     const modalElement = document.getElementById('confirmDialog');
  //     const modal = new bootstrap.Modal(modalElement!, { backdrop: 'static', focus: true, keyboard: false });

  //     const hideListener = () => {
  //       if (this.subscription) {
  //         this.subscription.unsubscribe();
  //         this.subscription = undefined;
  //       }
  //       modalElement!.removeEventListener('hide.bs.modal', hideListener);
  //     };
  //     modalElement!.addEventListener('hide.bs.modal', hideListener);
  //     modal.show();
  //     this.subscription = this.confirmDialog.confirmed.subscribe((result: boolean) => {
  //       // console.log(result)
  //       if (result) {
  //         // Reset the form programmatically
  //         this.schemeForm = this.fb.group({
  //           sections: this.fb.array([]),
  //           selfDeclaration: new FormControl('', Validators.requiredTrue)
  //         });

  //         const sectionsArray = this.schemeForm.get('sections') as FormArray;
  //         this.detailsRequired.forEach(section => {
  //           sectionsArray.push(this.createSection(section));
  //         });
  //       } else {

  //       }
  //       modal.hide();
  //     });
  //   }
  // }

  showSessionWarningPopup() {
    this.isWarningPopupShow=true;
    // Close any existing modal if open
    const openModals = document.querySelectorAll('.modal.show'); // Find all currently open modals
    openModals.forEach(modal => {
      const modalInstance = bootstrap.Modal.getInstance(modal);
      if (modalInstance) {
        modalInstance.hide(); // Close the modal
      }
    });
    const modalElement = document.getElementById('confirmDialog');
    // Ensure the modalElement exists and is not null
    if (!modalElement) {
      console.error('Modal element not found!');
      return;
    }

    // Check if the modal is already open
    if (modalElement.classList.contains('show')) {
      console.log('Modal is already open');
      return; // Skip opening the modal again
    }
    //const modal = new bootstrap.Modal(modalElement, { backdrop: 'static', focus: true, keyboard: false });
    this.sessionWarningModal = new bootstrap.Modal(modalElement, { backdrop: 'static', focus: true, keyboard: false });
  
    // Set title and message dynamically
    const titleElement = modalElement.querySelector('.popup-title');
    const messageElement = modalElement.querySelector('.modal-body');
  
    if (titleElement) {
      titleElement.textContent = 'Session Expiration Warning';
    }
  
    if (messageElement) {
      messageElement.textContent = 'Your session is about to expire due to inactivity.Do you want to continue?';
    }
  
    // Display the modal
    //modal.show();
    this.sessionWarningModal.show();
  
    // Unsubscribe from the previous subscription if needed
    if (this.subscription) {
      this.subscription.unsubscribe();
      this.subscription = undefined;
    }
  
    const hideListener = () => {
      if (this.subscription) {
        this.subscription.unsubscribe();
        this.subscription = undefined;
      }
      modalElement.removeEventListener('hide.bs.modal', hideListener);
    };
  
    // Add the event listener for the modal close event
    modalElement.addEventListener('hide.bs.modal', hideListener);
  
    // Handle user confirmation
    const yesButton = modalElement.querySelector('#confirmYesButton');
    const noButton = modalElement.querySelector('#confirmNoButton');
  
    // yesButton?.addEventListener('click', () => {
    //   this.isWarningPopupShow=false;
    //   alert("refresh");
    //   this.refreshtoken(); // Call the refresh token API
    //   this.updateExpirationTime(); // Reset expiration time
    //   //modal.hide(); // Hide the modal
    //   this.sessionWarningModal.hide(); // Hide the modal
    // });

    yesButton?.removeEventListener('click', this.handleYesButtonClick); // Remove existing listener
    this.handleYesButtonClick = () => {
      this.isWarningPopupShow = false;
      this.refreshtoken(); // Call the refresh token API
      this.updateExpirationTime(); // Reset expiration time
      this.sessionWarningModal.hide(); // Hide the modal
    };
    yesButton?.addEventListener('click', this.handleYesButtonClick); // Add a new listener
  
    noButton?.addEventListener('click', () => {
      this.isWarningPopupShow=false;
      this.cleanUp();
      this.onTimeout(); // Handle session timeout
      //modal.hide(); // Hide the modal
      this.sessionWarningModal.hide(); // Hide the modal
    });
  }
  getInactiveTimeInMinutes() {
    const currentTime = Date.now();
    const inactiveTimeInMs = currentTime - this.lastActivityTime;
    const inactiveTimeInMinutes = Math.floor(inactiveTimeInMs / (1000 * 60)); // Convert ms to minutes
    return inactiveTimeInMinutes;
  }
  showSessionOutPopup() {
    this.isLogoutPopupShow=true;
    // Close any existing modal if open
    const openModals = document.querySelectorAll('.modal.show'); // Find all currently open modals
    openModals.forEach(modal => {
      const modalInstance = bootstrap.Modal.getInstance(modal);
      if (modalInstance) {
        modalInstance.hide(); // Close the modal
      }
    });
    const modalElement = document.getElementById('confirmDialog');
    // Ensure the modalElement exists and is not null
    if (!modalElement) {
      console.error('Modal element not found!');
      return;
    }
  
    // Check if the modal is already open
    if (modalElement.classList.contains('show')) {
      console.log('Modal is already open');
      return; // Skip opening the modal again
    }
    //const modal = new bootstrap.Modal(modalElement, { backdrop: 'static', focus: true, keyboard: false });
    this.sessionWarningModal = new bootstrap.Modal(modalElement, { backdrop: 'static', focus: true, keyboard: false });
  
    // Dynamically remove the close button
    const closeButton = modalElement.querySelector('.modal-header button[data-bs-dismiss="modal"]');
    if (closeButton) {
      closeButton.style.display = 'none'; // Hide the close button
    }

    // Set title and message dynamically
    const titleElement = modalElement.querySelector('.popup-title');
    const messageElement = modalElement.querySelector('.modal-body');
  
    if (titleElement) {
      titleElement.textContent = 'Session Expired';
    }
  
    if (messageElement) {
      messageElement.textContent = 'Your session has expired, You will need to login again';
    }
  
    // Display the modal
    //modal.show();
    this.sessionWarningModal.show();
  
    // Unsubscribe from the previous subscription if needed
    if (this.subscription) {
      this.subscription.unsubscribe();
      this.subscription = undefined;
    }
  
    const hideListener = () => {
      if (this.subscription) {
        this.subscription.unsubscribe();
        this.subscription = undefined;
      }
      modalElement.removeEventListener('hide.bs.modal', hideListener);
    };
  
    // Add the event listener for the modal close event
    modalElement.addEventListener('hide.bs.modal', hideListener);
  
    // Handle user confirmation
    const yesButton = modalElement.querySelector('#confirmYesButton');
    const noButton = modalElement.querySelector('#confirmNoButton');

    if (noButton) {
      noButton.remove(); // Remove the button from the DOM
    }

    if (yesButton) {
      yesButton.textContent = 'OK'; // Change label to "OK"
    }
  
    yesButton?.removeEventListener('click', this.handleYesButtonClick); // Remove existing listener
    this.handleYesButtonClick = () => {
      this.cleanUp();
      this.onTimeout(); // Handle session timeout
      //modal.hide(); // Hide the modal
      this.sessionWarningModal.hide(); // Hide the modal
    };
    yesButton?.addEventListener('click', this.handleYesButtonClick); // Add a new listener
  
    // noButton?.addEventListener('click', () => {
    //   this.isWarningPopupShow=false;
    //   this.cleanUp();
    //   this.onTimeout(); // Handle session timeout
    //   //modal.hide(); // Hide the modal
    //   this.sessionWarningModal.hide(); // Hide the modal
    // });
  }
}

export default IdleTimer;